import MainNavigation from './MainNavigation';
import withProps from 'recompose/withProps';

export default withProps(props => ({
  navigation: props.isCheckout ? props.checkoutNavigation : props.navigation
}))(MainNavigation);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/MainNavigation/index.js